exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4c0eb06a] .el-scrollbar__wrap{overflow-x:hidden}[data-v-4c0eb06a] .el-tabs__header{border-bottom:1px solid #eeeeee}[data-v-4c0eb06a] .el-tabs__nav{margin-left:20px}[data-v-4c0eb06a] .el-tabs__item{height:60px;line-height:60px}.content[data-v-4c0eb06a]{padding:20px}\n", ""]);

// exports
